import React from "react";
import Layout from "Layout";
import Form from "./form";
import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import { animateScroll as scroll } from 'react-scroll';
import googleAnalytics from "fuction/googleAnalytics";

export default function Detail(props) {
  const { params } = props.match;
  const taskId = parseInt(params.id, 10);
  const auth = useAuth();
  const { request } = useApi();
  const [analysisData, setData] = React.useState([]);
  const [noises, setNoises] = React.useState([]);
  const [labels, setLabels] = React.useState([]);

  const [maxLabel, setMaxLabels] = React.useState([]);

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

   // 投稿分類有効確認
   const isAnalysis = () => {
    if (JSON.parse(localStorage.getItem("user"))?.options?.analysis == true || JSON.parse(localStorage.getItem("user"))?.options?.analysis== "true") {
        return true;
    }
    else {
      return false;
    }
  };

  const fetchData = () => {
    if (!auth.state.activeGroup) {
      return;
    }

    // タスク情報取得
    request({
      method: "GET",
      url: `config/:account_id/analysis/information/${auth.state.activeGroup}/${taskId}`,
    }).then((data) => {
      setData(data.data);
    });
    
    // ノイズ辞書一覧取得
    request({
      method: "GET",
      url: `config/:account_id/analysis/noises`,
    }).then((data) => {
      setNoises(data.data);
    });

    // 分類辞書一覧取得
    request({
      method: "GET",
      url: `config/:account_id/analysis/labels`,
    }).then((data) => {
      setLabels(data.data);
    });

    // 分類辞書登録上限数取得
    request({
      method: "POST",
      url: `config/:account_id/account`,
      data: {
        "attrs": [
          "max_labels",
        ]
      },
    }).then((account) => {
      // mapで描画するため、配列として設定
      let labelArry = [];
      let maxnum = account.data.max_labels;
      for (let i = 0;  i < maxnum;  i++) {
        labelArry.push(i);
      }
      setMaxLabels(labelArry);
    });
  };

  React.useEffect(() => {
    if(!isAnalysis()) return;

    // タイトル変更
    document.title = "Buzz Finder - 投稿分類タスク詳細";
    
    fetchData();
    scrollToTop()
  }, [auth.state.activeGroup]);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  return (
    <Layout
      content={
        <Form
          data={analysisData}
          noises={noises}
          labels={labels}
          labelMax={maxLabel}
          isMode="detail"
          dailyFlag={null}
          adminFlag={auth.state.user.admin}
        />
      }
    />
  );
}
